import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { colors } from '../context/Colors';
import Stats from './Stats';
import { useColorScheme } from 'react-native-appearance';
import Inventory from './Inventory';
import Progress from './Progress';
import Album from './Album';
import InventoryDetail from './InventoryDetail';
import MysteryWord from './MysteryWord';
import JigsawPuzzle from './JigsawPuzzle';

export default function StatsStack() {
  const StatsS = createStackNavigator();
  const Stack = createStackNavigator();
  const theme = useColorScheme() === 'dark' ? 'dark' : 'light';

  return (
    <StatsS.Navigator>
      <Stack.Screen
        name="Stats"
        options={{
          headerShown: false,
          cardShadowEnabled: false,
          cardStyle: {
            borderRadius: 10,
            backgroundColor: colors[theme].cardBg
          }
        }}
        component={Stats}
      />
      <Stack.Screen
        name="Inventory"
        options={{
          headerShown: false,
          cardShadowEnabled: false,
          cardStyle: {
            borderRadius: 10,
            backgroundColor: colors[theme].cardBg
          }
        }}
        component={Inventory}
      />
      <Stack.Screen
        name="InventoryDetail"
        options={{
          headerShown: false,
          cardShadowEnabled: false,
          cardStyle: {
            borderRadius: 10,
            backgroundColor: colors[theme].cardBg
          }
        }}
        component={InventoryDetail}
      />
      <Stack.Screen
        name="Progress"
        options={{
          headerShown: false,
          cardShadowEnabled: false,
          cardStyle: {
            borderRadius: 10,
            backgroundColor: colors[theme].cardBg
          }
        }}
        component={Progress}
      />
      <Stack.Screen
        name="Album"
        options={{
          headerShown: false,
          cardShadowEnabled: false,
          cardStyle: {
            borderRadius: 10,
            backgroundColor: colors[theme].cardBg
          }
        }}
        component={Album}
      />
      <Stack.Screen
        name="MysteryWord"
        options={{
          headerShown: false,
          cardShadowEnabled: false,
          cardStyle: {
            borderRadius: 10,
            backgroundColor: colors[theme].cardBg
          }
        }}
        component={MysteryWord}
      />
      <Stack.Screen
        name="JigsawPuzzle"
        options={{
          headerShown: false,
          cardShadowEnabled: false,
          cardStyle: {
            borderRadius: 10,
            backgroundColor: colors[theme].cardBg
          }
        }}
        component={JigsawPuzzle}
      />
    </StatsS.Navigator>
  );
}
